"use client";

import { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import { FaChevronDown } from "react-icons/fa";
import webLogo from "../../public/assets/webLogo.png";
import Image from "next/image";

const Navbar = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  let lastScrollY = 0;
  const router = useRouter();

  const testNames = [
    "Test 1", "Test 2", "Test 3", "Test 4", "Test 5", "Test 6",
    "Test 7", "Test 8", "Test 9", "Test 10", "Test 11", "Test 12",
    "Test 13", "Test 14", "Test 15", "Test 16", "Test 17", "Test 18"
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) setIsVisible(true);
      else if (window.scrollY > lastScrollY) setIsVisible(false);
      lastScrollY = window.scrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50 w-full">
      {/* Top Banner */}
      <div
        className={`bg-blue-700 text-white flex justify-center items-center transition-all duration-400 overflow-hidden ${
          isVisible ? "opacity-100 max-h-12 py-2" : "opacity-0 max-h-0 py-0"
        }`}
      >
        <p className="text-xs md:text-sm ml-5 md:ml-0">
          Start Your 5-Day Free Trial of CarerLab Pathology Software Now!
        </p>
        <button
          onClick={() => router.push("/signup")}
          className="ml-0 md:ml-5 mr-5 md:mr-0 text-xs md:text-sm bg-white text-blue-700 px-3 py-1 rounded flex items-center hover:bg-white/80"
        >
          START NOW <span className="ml-1">→</span>
        </button>
      </div>

      {/* Main Navbar */}
      <nav className="bg-white shadow-md">
        <div className="max-w-[1200px] mx-auto flex items-center justify-between px-4 py-2">
          <div className="flex-shrink-0">
            <Image
              src={webLogo}
              alt="Logo"
              width={80}
              height={45}
              className="rounded-xl"
            />
          </div>

          <div className="flex items-center space-x-6">
            {/* Reports Dropdown */}
            <div className="relative">
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="flex items-center space-x-1 text-blue-700 font-medium hover:underline"
              >
                Reports <FaChevronDown />
              </button>
              {isDropdownOpen && (
                <div className="absolute right-0 mt-2 w-[300px] bg-white border border-gray-200 rounded shadow-lg p-4 grid grid-cols-3 gap-2 text-blue-700 z-50">
                  {testNames.map((test, index) => (
                    <button
                      key={index}
                      onClick={() => {
                        router.push(`/test/test${index + 1}`);
                        setIsDropdownOpen(false);
                      }}
                      className="text-left hover:bg-blue-50 px-2 py-1 rounded text-sm w-full"
                    >
                      {test}
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Login */}
            <p
              onClick={() => router.push("/login")}
              className="text-sm md:text-md cursor-pointer hover:text-blue-500 hover:underline text-gray-500"
            >
              Login
            </p>

            {/* Start Free Trial */}
            <button
              onClick={() => router.push("/signup")}
              className="ml-2 md:ml-8 px-4 py-2 bg-blue-700 text-white rounded hover:bg-blue-600 text-sm md:text-md"
            >
              Start Free Trial
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
